'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _i18n = require('../i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_reactI18next.translate.setI18n(_i18n2.default);

var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer(props) {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));
    }

    _createClass(Footer, [{
        key: 'render',
        value: function render() {
            var t = this.props.t;


            return _react2.default.createElement(
                'div',
                { className: 'footer' },
                _react2.default.createElement(
                    'div',
                    { className: 'grid-container full-height' },
                    _react2.default.createElement(
                        'div',
                        { className: 'grid-x full-height vert-align' },
                        _react2.default.createElement(
                            'div',
                            { className: 'cell medium-auto small-12 medium-up-order-1 small-order-2' },
                            _react2.default.createElement(
                                'span',
                                { className: 'info' },
                                '\xA9 ',
                                new Date().getFullYear(),
                                ' Hawa Sliding Solutions'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: ['cell', 'medium-shrink', 'small-12', 'small-order-1', 'medium-up-order-2', 'grid-y', 'align-bottom', 'small-align-top'].join(' ') },
                            _react2.default.createElement(
                                'div',
                                { className: 'cell medium-shrink small-12 medium-up-order-1 small-order-1' },
                                _react2.default.createElement(
                                    'a',
                                    {
                                        href: t('impressum-link'),
                                        className: 'info link',
                                        target: '_blank',
                                        rel: 'noopener noreferrer'
                                    },
                                    'Impressum'
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell medium-shrink small-12 small-order-2 medium-up-order-2' },
                                _react2.default.createElement(
                                    'a',
                                    {
                                        href: t('data-protection-declaration-link'),
                                        className: 'info link',
                                        target: '_blank',
                                        rel: 'noopener noreferrer' },
                                    t('data-protection-declaration')
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Footer;
}(_react2.default.Component);

exports.default = (0, _reactI18next.translate)([])(Footer);


//////////////////
// WEBPACK FOOTER
// ./client/components/footer/index.js
// module id = 475
// module chunks = 0